import { useGetDetailOrders } from '@/hooks/order/useGetDetailOrders';
import { globalOrderResponseToGlobalDetailOrderItemUi } from '@/hooks/order/useGetDetailOrders/mapper';
import { responseToPagingUi } from '@/hooks/pagingMapper';
import { useEffect, useState } from 'react';
import { useImmer } from 'use-immer';
import { FilterUi } from './Filters/FilterUi';
import { OrdersDetaillUi, initialState } from './OrdersDetailUi';

export function useOrdersDetailViewController() {
  const [uiState, setUiState] = useImmer<OrdersDetaillUi>(initialState);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState<FilterUi>();

  const { data, isLoading } = useGetDetailOrders({
    page: currentPage,
    orderNumber: filter?.orderId,
    dateRange:
      filter?.startDate && filter.endDate
        ? [filter.startDate, filter.endDate]
        : undefined,
    sellerIds: filter?.sellers.map((sellerOption) => sellerOption.sellerId),
    kamIds: filter?.selectedKamIds,
    remissionStatusId: filter?.remissionStatusId,
    statusId: filter?.selectedStatusId.trim()
      ? filter?.selectedStatusId
      : undefined,
  });

  useEffect(() => {
    setUiState((draft) => {
      draft.isLoading = isLoading;
      if (draft.isLoading) {
        draft.paging = undefined;
        draft.items = [];
      }
    });
  }, [isLoading]);

  useEffect(() => {
    if (!data) return;
    setUiState((prev) => {
      prev.paging = responseToPagingUi(data);
      prev.items =
        data.data?.map(globalOrderResponseToGlobalDetailOrderItemUi) ?? [];
    });
  }, [data]);

  const onPageRequested = (page: number) => setCurrentPage(page);

  const onFilterChanged = (newFilter: FilterUi) => {
    setCurrentPage(1);
    setFilter(newFilter);
  };

  return {
    uiState,
    actions: {
      onFilterChanged,
      onPageRequested,
    },
  };
}
